export enum ImportSourceType {
  AD = "1",
  AJB = "2",
  SAMPLE = "3",
  SO = "31",
  RETURN = "4",
  FREIGHT = "5",
  ERROR = "6",
  AD_NOT_STORAGE = "Z"
}
